export const paymentColumns = [
  { id: "amount_paid", title: "Amount paid" },
  { id: "payment_status", title: "Payment status" },
  { id: "payment_due_date", title: "Due date" },
  { id: "payment_due_date_status", title: "Date date status" },
] as const;
